<template>
  <footer class="footer row site-footer">
        <div class="col-12 col-sm-5">
          <address>Copyright © 2019 Ahmed Abdelgawad</address>
        </div>
        <div class="col-12 col-sm-2">
          <address>
            <a href="https://www.linkedin.com/in/ahmed-abdelgawad-547727168/" target="_blank"><img src="http://clinic.ahmedelkayaty92.de/linkedin.png" alt=""></a>
            <a href="https://www.xing.com/profile/Ahmed_Abdelgawad5/cv?sc_o=mxb_p" target="_blank"><img src="../../assets/xing.png" width="30px"></a>
            <a href="https://plus.google.com/u/0/114830546087341606740" target="_blank"><img src="http://clinic.ahmedelkayaty92.de/google.png" width="30px" height="30px" alt=""></a>
          </address>
        </div>
        <div class="col-12 col-sm-5">
          <address>
            <a href="http://www.ahmedelkayaty92.de" target="_blank" style="color:#b2b2d2;text-decoration:none;">www.ahmedelkayaty92.de</a>
          </address>
        </div>
    </footer>
</template>

<script>
  export default {
    
  }
</script>

<style scoped>
footer {
  margin: 100px 0 0 0 !important;
  background-color: #292929;
  /* background-color: #000059; */
  /* background-color: #e7e7e7; */
  /* border-top: 60px solid rgba(88,88,88,0.7); */
  text-align: center;
  width: 100%;
}
footer>div>address, footer>div>address>a {
  color: #e8e8e8;
  padding: 20px 0;
  margin: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/Footer.vue